import RequestApi from "../../modules/requestApi";
import config from "../../../config.js";

/**
 * Темы авторизации
 */
const state = {
  // список тем
  themeList: [],
  // признак что список заружен
  themeIsLoaded: false,
  // параметры темы по умолчанию
  themeDefaultParams: {
    name: "Без названия",
    link: "",
    advertising_id: null,
    params: {
      textSuccess: {
        ru: "",
        en: "",
      },
      preview: {
        login: `/uploads/default/login.png`,
        signin: `/uploads/default/signin.png`,
        advertising: null,
      },
    },
    // цвета темы по умолчанию
    color: {
      files: {
        bgXS: null,
        bgXL: null,
        logo: null,
      },
      colors: [
        {
          name: "Основные цвета",
          params: [
            {
              text: {
                name: "Текст",
                value: "#ffffff",
              },
              bodyBg: {
                name: "Фон",
                value: "#1a385b",
              },
              link: {
                name: "Ссылка",
                value: "#aad5ff",
              },
              primary: {
                name: "Кнопки и акценты",
                value: "#005CFF",
              },
            },
            {
              btnText: {
                name: "Текст кнопок",
                value: "#fffff",
              },
              btnBorder: {
                name: "Обводка кнопок",
                value: "transparent",
              },
              inputText: {
                name: "Текст поля ввода",
                value: "#98b3cf",
              },
              inputBg: {
                name: "Фон поля ввода",
                value: "#ffffff",
              },
              inputBorder: {
                name: "Обводка поля ввода",
                value: "#aad5ff",
              },
            },
            {
              listText: {
                name: "Текст списков",
                value: "#ffffff",
              },
              listBg: {
                name: "Фон списков",
                value: "#235087",
              },
              list_border: {
                name: "Обводка списков",
                value: "transparent",
              },
              backgroundBg: {
                name: "Фон подложки",
                transparency: true,
                value: "transparent",
              },
            },
          ],
        },
        {
          name: "Реклама. Текстовый блок",
          params: [
            {
              advertisingText: {
                name: "Текст блока",
                value: "#ffffff",
              },
              advertisingBg: {
                name: "Фон блока",
                value: "transparent",
              },
            },
          ],
        },
      ],
    },
  },
};

const mutations = {
  // список тем
  SET_THEME_LIST(state, data) {
    // сортируем по алфавиту
    state.themeList = data.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0
    );
  },
  // смена признака загрузки списка
  SET_THEME_IS_LOADED(state, data) {
    state.themeIsLoaded = data;
  },
  // перезаписывает объект в списке
  SET_THEME_ITEM(state, data) {
    // определяем индекс по id
    const index = state.themeList.findIndex((item) => item.id === data.id);
    if (index !== -1) {
      // перезаписываем элемент, через удаление, иначе реактивность не срабатывает
      state.themeList.splice(index, 1, { ...state.themeList[index], ...data });
    }
  },
};

const actions = {
  // загрузка данных по списку тем
  themeListLoad({ commit, state }) {
    if (!state.themeIsLoaded) {
      return new Promise((resolve, reject) => {
        RequestApi.themeList()
          .then((data) => {
            commit("SET_THEME_LIST", data);
            commit("SET_THEME_IS_LOADED", true);
          })
          .catch(reject);
      });
    }
  },
  // добавление темы
  createTheme({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.createTheme(params)
        .then((data) => {
          commit("SET_THEME_LIST", [...state.themeList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // копирование темы
  copyTheme({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.copyTheme(params)
        .then((data) => {
          commit("SET_THEME_LIST", [...state.themeList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // редактирование темы
  editTheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.editTheme(params)
        .then((data) => {
          commit("SET_THEME_ITEM", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // удаление темы
  deleteTheme({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.deleteTheme(params)
        .then((data) => {
          commit(
            "SET_THEME_LIST",
            state.themeList.filter((item) => item.id !== params.id)
          );
          resolve(data);
        })
        .catch(reject);
    });
  },
  // восстановление темы
  recoveryTheme({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.recoveryTheme(params)
        .then((data) => {
          commit("SET_THEME_LIST", [...state.themeList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
};

const getters = {
  // список тем
  themeList: (state) => {
    return state.themeList;
  },
  // объект по id
  getTheme: (state) => (id) => {
    return state.themeList.find((item) => item.id === id);
  },
  // параметры темы по умолчанию
  themeDefaultParams: (state) => {
    return state.themeDefaultParams;
  },
  // признак что список заружен
  themeIsLoaded: (state) => {
    return state.themeIsLoaded;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
